var exports = {
  "ZK": "ChannelFollowSuccessModal.module__hero___VlI3eW",
  "Wp": "ChannelFollowSuccessModal.module__patternImage___VlI3eW",
  "RG": "ChannelFollowSuccessModal.module__composition___VlI3eW",
  "Dr": "ChannelFollowSuccessModal.module__sourceIconWrap___VlI3eW",
  "$f": "ChannelFollowSuccessModal.module__guildIcon___VlI3eW",
  "hI": "ChannelFollowSuccessModal.module__announcementBadge___VlI3eW",
  "aw": "ChannelFollowSuccessModal.module__announcementBadgeIcon___VlI3eW",
  "UE": "ChannelFollowSuccessModal.module__arrow___VlI3eW",
  "rf": "ChannelFollowSuccessModal.module__body___VlI3eW",
  "DD": "ChannelFollowSuccessModal.module__title___VlI3eW",
  "h_": "ChannelFollowSuccessModal.module__description___VlI3eW",
};

module.exports = exports;
